import qs from 'qs';
import { network } from 'services/network';

import { QueryParams } from 'api/queries/getRiskRegisterAuditLog.query';

export const getRiskRegisterAuditLog = (params: QueryParams) => {
    const querystring = qs.stringify(params, { addQueryPrefix: true, skipNulls: true });

    const url = `api/bo/getRiskRegisterAuditLog${querystring}`;

    return network.get(url).then((response) => {
        return response.data;
    });
};
